// Want hits store: the in-binder star's filled state (wants_board ?hits=), a
// per-binder Signed-in read (viewer-binder-read). A star tap needs no cache
// invalidation: wantlist.svelte.js's optimistic override wins over the hits.
import { createViewerBinderRead } from './viewer-binder-read.svelte.js';
import { fetchWantHits } from '../services/wants-board-api.js';
import { wantHitKey } from '../logic/wantlist-logic.js';

const hits = createViewerBinderRead(
  fetchWantHits,
  (data) => new Set((data.hits || []).map(wantHitKey))
);
export const wantHitsState = hits.state;
/** Called when a binder opens, and again when its first sync lands. */
export const loadWantHits = hits.load;

/**
 * Does the Viewer want this card of the binder on screen?
 * @param {string | null | undefined} binderUrl
 * @param {Parameters<typeof wantHitKey>[0]} card
 */
export function isWantHit(binderUrl, card) {
  const key = wantHitKey(card);
  return key !== '' && (hits.valueFor(binderUrl)?.has(key) ?? false);
}
